
import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";
import API_URL from '../config';

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);
  const { token } = useAuth();
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const [isWidgetVisible, setIsWidgetVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  // Toujours lire le token au moment de l'appel pour éviter les closures périmées
  const getHeaders = () => ({
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json'
  });

  const fetchCart = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/api/cart`, { headers: getHeaders() });
      setCartItems(res.data);
    } catch (err) {
      console.error("Erreur récupération panier:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchCart();
    } else {
      setCartItems([]);
      setLoading(false);
    }
  }, [token]);

  const addToCart = async (item) => {
    try {
      await axios.post(`${API_URL}/api/cart/add`, item, { headers: getHeaders() });
      await fetchCart();
      setIsWidgetOpen(true);
      setIsWidgetVisible(true);
    } catch (err) {
      console.error("Erreur ajout panier:", err);
      setMessage("Impossible d'ajouter l'article au panier");
    }
  };

  const removeFromCart = async (id) => {
    try {
      await axios.delete(`${API_URL}/api/cart/${id}`, { headers: getHeaders() });
      await fetchCart();
    } catch (err) {
      console.error("Erreur suppression panier:", err);
      setMessage("Impossible de supprimer l'article");
    }
  };

  const updateQuantity = async (id, qty) => {
    try {
      await axios.put(`${API_URL}/api/cart/item/${id}`, { quantity: qty }, { headers: getHeaders() });
      await fetchCart();
    } catch (err) {
      console.error("Erreur mise à jour quantité panier:", err);
      setMessage("Impossible de mettre à jour la quantité");
    }
  };

  const clearCart = async () => {
    try {
      await axios.delete(`${API_URL}/api/cart`, { headers: getHeaders() });
      setCartItems([]);
      setIsWidgetOpen(false);
      setIsWidgetVisible(false);
    } catch (err) {
      console.error("Erreur vider panier:", err);
      setMessage("Impossible de vider le panier");
    }
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        fetchCart,
        isWidgetOpen,
        setIsWidgetOpen,
        isWidgetVisible,
        setIsWidgetVisible,
        loading,
        message
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
